<div class="shared-chart-banner" role="status">
  <i class="fas fa-share-nodes shared-chart-banner__icon" aria-hidden="true"></i>
  <div class="shared-chart-banner__text">
    @if (mode() === 'member') {
      <span class="shared-chart-banner__title">{{ text().member }}</span>
      @if (chartName()) {
        <span class="shared-chart-banner__name">{{ chartName() }}</span>
      }
    } @else {
      <span class="shared-chart-banner__title">{{ text().guestTitle }}</span>
      @if (chartName()) {
        <span class="shared-chart-banner__name">{{ chartName() }}</span>
      }
      <span class="shared-chart-banner__message">{{ text().guestMessage }}</span>
    }
  </div>
  <div class="shared-chart-banner__actions">
    @if (mode() === 'member') {
      @if (saveAvailable()) {
        <button eBtn size="sm" type="button" color="primary" icon="floppy-disk" data-test-id="shared-banner-save"
                (click)="saveRequested.emit()">{{ text().save }}</button>
      } @else {
        <!-- Cycle/composite/moment: de broncharts horen bij de deler, dus niet op te slaan. -->
        <span class="shared-chart-banner__message" data-test-id="shared-banner-save-unavailable">{{ text().saveUnavailable }}</span>
      }
    } @else {
      <button eBtn size="sm" type="button" color="primary" icon="right-to-bracket" data-test-id="shared-banner-login"
              (click)="loginRequested.emit()">{{ text().login }}</button>
      @if (showRegister()) {
        <button eBtn size="sm" type="button" color="highlight" icon="user-plus" data-test-id="shared-banner-register"
                (click)="registerRequested.emit()">{{ text().register }}</button>
      }
    }
    <!-- Extra's van de host naast de knoppen (gastpagina: de taalkeuze). -->
    <ng-content select="[bannerExtra]"></ng-content>
  </div>
</div>
